export enum AdditionalStagesTypes {
    GET_LIST = '@additionalStages/GET_LIST',
    REQUEST_GET_LIST = '@additionalStages/REQUEST_GET_LIST',
    REQUEST_SAVE_ADDITIONAL_STAGE = '@additionalStages/REQUEST_SAVE_ADDITIONAL_STAGE',
    SAVE_ADDITIONAL_STAGE = '@additionalStages/SAVE_ADDITIONAL_STAGE',
}

export type AdditionalStage = {
    additionalExercises: string[];
    description?: Record<string, string>;
    image?: string;
    id: string;
    name: Record<string, string>;
    publishFrom: Date | null;
    publishTo: Date | null;
    relatedMission: string;
    rewards: string[];
};

export type AdditionalStagesState = {
    isLoading: boolean;
    additionalStages: AdditionalStage[];
};

export type AdditionalStagesAction<Payload> = {
    type: AdditionalStagesTypes;
    payload: Payload;
};

export type AdditionalStageReducer = (
    state: AdditionalStagesState,
    actions: AdditionalStagesAction<AdditionalStagesState>,
) => AdditionalStagesState;
